// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Layout-module__container___v_n8R *{text-transform:none !important}", "",{"version":3,"sources":["webpack://./src/pages/Hub/Layout/Layout.module.scss"],"names":[],"mappings":"AACG,oCACC,8BAAA","sourcesContent":[".container {\n   & * {\n    text-transform: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Layout-module__container___v_n8R"
};
export default ___CSS_LOADER_EXPORT___;
